import { MediaMatcher } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { CommonConfig } from '../shared/common-config/common-config';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
 mobileQuery: MediaQueryList;
  constructor(private media: MediaMatcher,
    private commonConfig: CommonConfig,
    private platform: Platform,) {
     this.mobileQuery = media.matchMedia('(max-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
  }

  is_mobile() {
    let mobile = this.platform.ANDROID || this.platform.IOS || this.mobileQuery.matches;
    return mobile;

  }
}
